import { render, staticRenderFns } from "./SortLetterUp.vue?vue&type=template&id=82d5ac76"
import script from "./SortLetterUp.vue?vue&type=script&lang=js"
export * from "./SortLetterUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports